import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { Subject } from 'rxjs';
import { UnsavedResultState } from '../components/unsaved-modal-dialog/unsaved-modal-dialog.component';
import { AuthService } from './auth.service';
import { ComponentCanDeactivate } from './component-can-deactivate';
import { TerminalsService } from './terminals.service';

@Injectable()
export class CanDeactivateTerminalGuard  {
  resultSelection: Subject<boolean> = new Subject<boolean>();

  constructor(public dialog: MatDialog, public authService: AuthService, public terminalsService: TerminalsService) {
  }

  canDeactivate(component: ComponentCanDeactivate) {
    if (component.canDeactivate()) {
      return true;
    } else {
      if (this.authService.isLoggedIn) {
        var dialogRef = this.terminalsService.unsavedQuestionDialog(true, true, this.terminalsService.isModelSaveable());

        dialogRef.afterClosed().subscribe(result => {
          if (result == UnsavedResultState.Save) {
            this.terminalsService.saveModel().then(result => { this.resultSelection.next(true); });
          } else if (result == UnsavedResultState.Discard) {
            this.terminalsService.discardChanges();
            this.resultSelection.next(true);
          } else {
            this.resultSelection.next(false);
          }
        });

        return this.resultSelection;
      } else {
        return true;
      }
    }
  }
}
